import JournalList from 'components/journals/JournalList';
import ProjectDetails from 'components/projects/ProjectDetails';
import LocationList from 'components/locations/LocationList';
import AdministrationPage from 'components/admin/AdministrationPage';
import BillingPage from 'components/billing/BillingPage';
import Person from "@material-ui/icons/Person";
import Reorder from "@material-ui/icons/Reorder";
import Dashboard from "@material-ui/icons/Dashboard";
import Room from "@material-ui/icons/Room";
import Print from "@material-ui/icons/Print";
import CreditCard from "@material-ui/icons/CreditCard"
import JournalDetails from '../components/journals/JournalDetails';
import UserList from '../components/users/UserList';


export const NavRoutes = [
  {
    path: '/reports',
    name: 'Dashboard',
    short: 'Dashboard',
    mini: 'D',
    icon: Dashboard,
    component: ProjectDetails
    },
    {
    path: "/journals",
    name: "Journals",
    short: "Journals",
    mini: "JL",
    icon: Reorder,
    component: JournalList
  },
  
  {
    path: '/users',
    name: 'Users',
    short: 'User',
    mini: 'R',
    icon: Person,
    component: UserList
    },
  {
  path: '/locations',
  short: 'Locations',
  name: 'Locations',
  mini: 'L',
  icon: Room,
  component: LocationList
  },
  {
  path: '/administration',
  short: 'Administration',
  name: 'Administration',
  short: 'Admin',
  mini: 'A',
  icon: Print,
  component: AdministrationPage
  }
  ,
  {
  path: '/billing',
  short: 'Billing',
  name: 'Billing',
  short: 'Billing',
  mini: 'BL',
  icon: CreditCard,
  component: BillingPage
  }
];



/*<Switch>

//TODO: Import from NavRoutes 

<Route path='/project/:id' component={ProjectDetails} />
<Route path='/signin' component={SignIn}/>
<Route path='/signup' component={SignUp} />
<Route path='/create' component={CreateProject} />
<Route path='/journals' component={JournalList} />
<Route path='/journal/:id' component={JournalDetails} />
<Route path='/locations' component={LocationList} />
<Route path='/administration' component={AdministrationPage} />
<Route exact path='/' component={JournalList} />
</Switch>*/
            
export default NavRoutes;



// WEBPACK FOOTER //
// ./src/routes/NavRoutes.js